import { render, staticRenderFns } from "./FullDetails.vue?vue&type=template&id=f29afdde&scoped=true&"
import script from "./FullDetails.vue?vue&type=script&lang=js&"
export * from "./FullDetails.vue?vue&type=script&lang=js&"
import style0 from "./FullDetails.vue?vue&type=style&index=0&id=f29afdde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29afdde",
  null
  
)

export default component.exports